// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  URL_PREDIAL: "https://nld.gob.mx/predial_ws/Predial",
  //URL_PREDIAL: "https://indeweb.net/predial_ws/Predial",
  APIKEY_PREDIAL: "2c89d9ff8e5287e78daa5af780b09161",
 // METODO_PREDIAL: "/procesar3dsec",
  METODO_PREDIAL: "/procesar3dsec",
  METODO_PREDIAL2: "/predialtest",
  KEY_CAPTCHA: "6Lf5NcgUAAAAAFI1G43lDvhCSETipmTX5IySLdkz",
  APIKEY_RECLUTAMIENTO: "1fb13e41a6df7bb169229fe20470321f",
  URL_CIAC: "https://mciac2018.nld.gob.mx/miniciac_ws/Ciacnld",
  APIKEY_CIAC: "5a508afd0c735ec71231b0d4fa7c8a3d",
  URL_QUEJATEL: "https://quejatel1618.nld.gob.mx/quejatel_ws/Publico",
  APIKEY_QUEJATEL: "66f59ca2b0571f7359e0ef0dc608ac4d",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
